<script lang="ts">
  import type { Seminar } from './types';
  import dataService from './utils/data-service.svelte';
  import SpeakersGallery from './SpeakersGallery.svelte';

  type Props = {
    seminar: Seminar;
  }

  const { seminar }: Props = $props();
  const { title, speakers, start_time, end_time, theatre, link } = seminar;
  const theatreData = dataService.getTheatre(theatre);
  const speakersData = dataService.getSpeakers(speakers);

  const times = [];
  if (start_time) times.push(start_time.toLocaleTimeString('en-UK', { hour: '2-digit', minute: '2-digit' }));
  if (end_time) times.push(end_time.toLocaleTimeString('en-UK', { hour: '2-digit', minute: '2-digit' }));
  const timeStr = times.join(' - ');
</script>

<div class="seminar-tile relative transition-transform bg-stone">
  <div class="p-5">
    <p class="mt-0 mb-2 uppercase">{timeStr}{#if theatreData}&nbsp;&nbsp;<b>{theatreData.name}</b>{/if}</p>
    <h3 class="m-0 text-pink">{title}</h3>
  </div>
  <a href={link} class="absolute inset-0">
    <span class="sr-only">View details</span>
  </a>
  {#if speakersData?.length}
    <div class="p-5 pt-0 relative">
      <SpeakersGallery speakers={speakersData} />
    </div>
  {/if}
</div>